import { render } from "./TwoColumn.vue?vue&type=template&id=63e78608&scoped=true"
import script from "./TwoColumn.vue?vue&type=script&lang=js"
export * from "./TwoColumn.vue?vue&type=script&lang=js"

import "./TwoColumn.vue?vue&type=style&index=0&id=63e78608&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e78608"]])

export default __exports__